import { LAMPORTS_PER_SOL } from '@solana/web3.js';

//JITO TIPS
//min jito tip 0.000001 SOL
export const createOpenbookMarketJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const createTokenJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const deployPoolJitoTipDefault = 0.0001 * LAMPORTS_PER_SOL;

export const freezerJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const jitoStressTestJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const removeLiquidityJitoTip = 0.001 * LAMPORTS_PER_SOL;

export const manualSwapJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const rapidLaunchJitoTip = 0.000031 * LAMPORTS_PER_SOL;
export const rapidLaunchMixerJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const solManagerJitoTip = 0.000001 * LAMPORTS_PER_SOL;

export const tokenManagerJitoTip = 0.000001 * LAMPORTS_PER_SOL;

export const tokenMixerSalesBaseJitoTipDafault = 0.000001;
export const tokenMixerSalesMixerJitoTipDafault = 0.000001;
export const tokenMixerSalesSalesJitoTipDafault = 0.000001;

export const volumeMakerV2JitoTipDafault = 0.000001;

export const volumeWalletControlJitoTipDefault = 0.000001;

export const pumpswapBuyJitoTip = 0.00001 * LAMPORTS_PER_SOL;
export const pumpswapSellJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const volumeMakerPumpswapDefaultJitoTip = 0.00001 * LAMPORTS_PER_SOL;
export const volumeMakerPumpswapFeeReserve = 0.02 * LAMPORTS_PER_SOL;

export const volumeSellerPumpswapDefaultJitoTip = 0.00001 * LAMPORTS_PER_SOL;

export const removeLiquidityPumpswapJitoTip = 0.0001 * LAMPORTS_PER_SOL;

//PRIORITY FEES (microLamports)
export const transferSolPriorityFee = 10000;
export const transferSolPriorityLimit = 20000;

export const createTokenPriorityFee = 500000;

export const removeLiquidityManualRemovePriorityFee = 2000000;
export const removeLiquidityScanningPriorityGas: number = 2000000;
export const removeLiquidityManualSwapPriorityGas: number = 24000;
export const removeLiquidityTimedManualSwapPriorityGas: number = 24000;
export const removeLiquidityAutoSwapPriorityGas: number = 24000;
export const removeLiquidityBurnLpPriorityGas: number = 20000;

export const volumeMakerV2MinPriorityFeeJitoLamports = 500;
export const volumeMakerV2MaxPriorityFeeJitoLamports = 700;
export const volumeMakerV2MinPriorityFeeRPCLamports = 500;
export const volumeMakerV2MaxPriorityFeeRPCLamports = 700;

export const volumeWalletControlMinPriorityFeeJitoLamports = 500;
export const volumeWalletControlMaxPriorityFeeJitoLamports = 700;
export const volumeWalletControlMinPriorityFeeRPCLamports = 500;
export const volumeWalletControlMaxPriorityFeeRPCLamports = 700;

export const pumpswapBuyUnitLimit = 150000;
export const pumpswapSellUnitLimit = 150000;
export const removeLiquidityPumpswapRemoveUnits = 150000;

export const volumeMakerPumpswapMinPriorityFeeJitoLamports = 500;
export const volumeMakerPumpswapMaxPriorityFeeJitoLamports = 550;
export const volumeMakerPumpswapMinPriorityFeeRPCLamports = 500;
export const volumeMakerPumpswapMaxPriorityFeeRPCLamports = 550;

export const volumeSellerPumpswapMinPriorityFeeJitoLamports = 500;
export const volumeSellerPumpswapMaxPriorityFeeJitoLamports = 550;
export const volumeSellerPumpswapMinPriorityFeeRPCLamports = 500;
export const volumeSellerPumpswapMaxPriorityFeeRPCLamports = 550;

export const removeLiquidityPumpswapBurnLpPriorityGas = 20000;
export const removeLiquidityPumpswapManualRemovePriorityGas = 200000;
export const removeLiquidityPumpswapRemovePriorityGas = 200000;

export const burnerPriorityFee = 20000;
